import React from 'react';
import { Row } from 'reactstrap';
import { Link } from 'gatsby';

import logo from 'assets/images/logo.svg';
import HamburgerMenu from 'components/hamburgerMenu';
import AuthLinks from 'components/authLinks';
import { NAV_LINKS } from 'context/app/constants';

import {
  header,
  navRow,
  logoColumn,
  linksColumn,
  menuColumn,
  rightCol,
  brandLogo,
  activeLink,
} from './scss/Header.module.scss';

const Header = () => (
  <header className={header}>
    <nav>
      <Row noGutters className={navRow}>
        <div className={logoColumn}>
          <Link to="/">
            <img src={logo} className={brandLogo} alt="Afex Trading" />
          </Link>
        </div>
        <div className={linksColumn}>
          <div>
            {NAV_LINKS.map(l => (
              <Link key={l.label} to={l.href} activeClassName={activeLink}>
                {l.label}
              </Link>
            ))}
          </div>
        </div>
        <div className={menuColumn}>
          <div className={rightCol}>
            <AuthLinks theme="red" />
            <HamburgerMenu />
          </div>
        </div>
      </Row>
    </nav>
  </header>
);

export default Header;
